/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Has obtenido una justificación comercial para acceder a los datos de los clientes."
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Se registrará y realizará un seguimiento de tu actividad de descarga por cumplimiento de normas de seguridad."
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "¿Deseas continuar?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Al descargar, usted reconoce lo siguiente:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
